import type { ReactNode } from 'react'
import React, { createContext, useContext, useMemo } from 'react'
import { ArrayParam, useQueryParams } from 'use-query-params'

import { useCurrentShop } from '../../Dashboard/hooks/useCurrentShop'

type ExperimentFlags =
  | 'dashboard-challenge-experiment-VARIANT_1'
  | 'dashboard-challenge-experiment-VARIANT_2'
  | 'dashboard-challenge-experiment-VARIANT_3'
  | 'dashboard-challenge-experiment-CONTROL'
  | 'dashboard-challenge-experiment-EXPERIMENT_NOT_ALLOWED'
  | 'dashboard-challenge-experiment-NO-GROUP'

const ExperimentsContext = createContext<Array<ExperimentFlags>>([])

export const ExperimentsProvider = ({ children }: { children: ReactNode }) => {
  const { currentShop } = useCurrentShop()
  const [{ experiment }] = useQueryParams({ experiment: ArrayParam })

  const activeExperiments = useMemo(() => {
    const activeExperimentForced = experiment

    if (activeExperimentForced) {
      return activeExperimentForced
    }

    if (!currentShop) return []

    return currentShop.activeExperiments
  }, [currentShop, experiment]) as Array<ExperimentFlags>

  return (
    <ExperimentsContext.Provider value={activeExperiments}>{children}</ExperimentsContext.Provider>
  )
}

export const useExperiments = () => {
  const context = useContext(ExperimentsContext)
  if (context === undefined) {
    throw new Error('useExperiments must be used within an ExperimentsProvider')
  }

  return context
}
